export default {
  "memberStatistics": "会员数据统计",
  "distributionByMemberTypeAndLevel": "按会员类型与级别分布，口径与「会员列表」一致",
  "viewMembers": "查看会员列表",
  "byMemberType": "按会员类型",
  "totalMembers": "在册合计",
  "change": "环比",
  "vsLastMonth": "较上月",
  "noMemberTypeData": "暂无会员类型数据",
  "share": "占",
  "byMemberLevel": "按会员级别",
  "noMemberLevelData": "暂无级别数据",
  "revenue": "资金收入",
  "membershipFeeAndEventRegistrationRevenue": "会费与活动报名收入构成、近 12 个月趋势",
  "viewPaymentRecords": "查看缴费记录",
  "revenueBreakdown": "收入构成",
  "noRecordedRevenue": "暂无已入账收入",
  "revenueOverTheLast12Months": "近 12 个月收入趋势",
  "membershipFees": "会员会费",
  "eventRegistration": "活动报名",
  "newMembersThisYear": "今年新增会员",
  "newMembersThisMonth": "本月新增",
  "noPendingApplications": "暂无待审核申请",
  "activeMemberRate": "会员活跃率",
  "requiresRecentMiniProgramLoginData": "需小程序用户最近登录数据",
  "digitalMembershipCardsIssued": "电子会员证发放",
  "membershipCardsAreNotAvailableYet": "会员证功能尚未接入",
  "totalRevenue": "累计收入",
  "includesMembershipFeesAndEventRegistrations": "含会费与活动报名",
  "membershipFeeRevenue": "会费收入",
  "collectedThisYear": "今年已收",
  "outstandingMembershipFees": "待收会费",
  "noOutstandingPayments": "暂无待收",
  "cNY10k": "万元",
  "cNY": "元",
  "couldNotLoadTheDashboard": "数据看板加载失败",
  "membershipFeeSettings": "会费设置",
  "renewalManagement": "续费管理",
  "feeDue": "💡 应缴会费 =",
  "baseAnnualFeeForThePosition": "职务基准年费",
  "termMultiplier": "届别档位系数",
  "memberTypeMultiplier": "会员类型系数",
  "yearsInTheBillingCycle": "周期年数",
  "midTermEnrollmentIsProratedBy": "，中途入会再按",
  "remainingMonths": "剩余月份",
  "currentTerm": "折算。当前届别：",
  "exampleACorporateMemberServingAs": "示例：企业会员任会长（基准 ¥8000），第4届系数 1.0、届期 3 年 → 8000 × 1.0 × 1.2 × 3 =",
  "perTermThisPageManagesPricing": "/ 届。本页只维护「单价规则」；",
  "amountsDuePerPeriodPaidOutstanding": "具体每期该缴多少、已缴/待缴、续费与催缴",
  "areAvailableIn": "见",
  "changesHere": "。本页改动",
  "takeEffectImmediatelyWithoutASeparate": "即时生效、无需保存",
  "feeSettingTabs": "会费设置项",
  "terms": "届别档位",
  "addTerm": "新增届别",
  "termStatusIsDeterminedFrom": "届期状态按",
  "theTermStartEndDates": "届期起始日 / 届末日期",
  "andTheCurrentDate": "与当前日期自动判定：",
  "active": "进行中",
  "termsAreIncludedInCurrentBilling": "的届别参与当期计费，已结束的届别归档、尚未开始的届别未生效。届末日期即会员到期日。当前：",
  "termName": "届别名称",
  "termDatesExpiry": "届期区间 / 到期日",
  "term": "届期",
  "years": "年 ·",
  "expires": "到期",
  "multiplier": "档位系数",
  "termStatus": "届期状态",
  "billing": "计费",
  "actions": "操作",
  "edit": "编辑",
  "delete": "删除",
  "noTermsYetAddATerm": "暂无届别，请新增届别",
  "total": "共",
  "records": "条",
  "positionsAndBaseAnnualFees": "职务与基准年费",
  "addPosition": "新增职务",
  "theBaseAnnualFeeIsThe": "基准年费为职务的年度标准金额；每届计费会按届期年数计算，每年计费则按年度计算。",
  "positionName": "职务名称",
  "baseAnnualFee": "基准年费",
  "billingFormula": "计费方式",
  "termMultiplierTypeMultiplier": "× 届别系数 × 类型系数",
  "cycle": "周期",
  "status": "状态",
  "noPositionsYetAddAPosition": "暂无职务，请新增职务",
  "memberTypeRates": "会员类型费率",
  "editMemberTypeRates": "修改会员类型费率",
  "useEditMemberTypeRatesTo": "点击「修改会员类型费率」可统一设置各会员类型的档位系数；会员类型及入会登记字段请在「入会申请」页面维护。",
  "memberType": "会员类型",
  "baseAnnualFeeTermMultiplier": "基准年费 × 届别系数 ×",
  "examplePerPeriod": "每期示例",
  "description": "说明",
  "midTermEnrollment": "中途入会",
  "chooseHowToChargeMembersWho": "会员在届期开始后才入会时的计费方式。两种方式二选一；「按剩余月份折算」可设置触发门槛 —— 届期刚开始的少量月份（如一两个月）不触发折算，仍按全额收取。",
  "changesTakeEffectImmediately": "本区设置即时生效",
  "prorateByRemainingMonths": "按剩余月份折算",
  "feeDueFeePerPeriodRemaining": "应缴 = 每期应缴 × 入会时距届末到期日的剩余月数 ÷ 届期总月数",
  "prorationAppliesAfter": "触发条件：届期已进行满",
  "monthsOfTheTermHaveElapsed": "个月后入会才触发折算",
  "beforeTheThresholdChargeTheFull": "未达门槛（如届期刚开始一两个月）不折算，按全额收费。可填 1–60 个月，默认 6 个月。",
  "fixedAmount": "固定金额",
  "chargeTheSameAmountForMid": "不论何时入会、剩多少个月，中途入会一律收取同一笔金额",
  "fixedMidTermEnrollmentFee": "中途入会固定收取 ¥",
  "applyThisFeeWhenJoiningAt": "届期开始后（已过 1 个月及以上）入会即按此金额收取。当前：",
  "examples": "生效示例：",
  "forAPresidentInTerm4": "以「第4届（2025-07-01 – 2028-06-30）」· 会长 为例",
  "joinInTheFirstMonth2025": "· 届期首月入会（2025-07-01）→",
  "fullFee": "（全额）",
  "joinBeforeTheThreshold202512": "· 门槛前入会（2025-12-01，届期已过 5 个月）→",
  "noProrationFullFee": "（未触发，全额）",
  "joinOnTheThresholdDate2026": "· 门槛当日起入会（2026-01-01）→",
  "prorated29Of36MonthsRemaining": "（触发折算，剩 29 / 36 个月）",
  "regularEnrollmentFullFee": "（视为正常入会，全额）",
  "joinAfter8Months202603": "· 届期已过 8 个月入会（2026-03-01）→",
  "fixedAmountRegardlessOfRemainingMonths": "（固定金额，与剩余月份无关）",
  "thisPricingRuleWillBeConfigured": "该单价规则将在下一步继续配置",
  "feeCalculator": "会费试算",
  "calculateTheFeePerPeriodBy": "按「会员类型 × 职务 × 届别」试算单期会费，支持中途入会折算；批量应缴与续费见「续费管理」。",
  "selectAMemberType": "请选择会员类型",
  "position": "选择职务",
  "selectAPosition": "请选择职务",
  "enrollmentTerm": "选择入会届别",
  "selectAnEnrollmentTerm": "请选择入会届别",
  "midTermEnrollment1": "中途入会（",
  "currentRule": "当前规则：",
  "selectEnrollmentDate": "选择入会日期",
  "calculateFee": "计算会费",
  "selectAMemberTypePositionAnd": "选择会员类型、职务与届别后点击【计算会费】",
  "termMultiplier2": "× 届别系数",
  "typeMultiplier": "× 类型系数",
  "year": "/ 年",
  "billingCycle": "计费周期：",
  "yearsFeePerPeriod": "年）→ 每期应缴",
  "membershipExpires": "会员到期日：",
  "term3": "（届期",
  "eGTerm6": "如：第6届",
  "termStartDate": "届期起始日",
  "termEndDateMembershipExpiry": "届末日期（会员到期日）",
  "termYearsCalculatedFromDates": "届期年数（按日期自动换算)",
  "termStatusAutomatic": "届期状态（自动判定)",
  "notes": "备注",
  "optionalEGFoundingTermProposed": "选填，如：创会届 / 拟任届别",
  "enterTheTermEndDateTo": "请填写届末日期，否则无法确定会员到期日",
  "billingFormulaBaseAnnualFee": "计费方式：基准年费",
  "presidentTermMultiplier": "（会长） × 档位系数",
  "typeMultiplier12CorporateMember": "× 类型系数 1.2（企业会员） ×",
  "years4": "年",
  "estimatedFeePerPeriod": "→ 该届别每期会费 ≈",
  "years5": "年）",
  "termStatusIsDeterminedAutomaticallyFrom": "届期状态按届期起止日期与当前日期自动判定，无需人工设置；仅「进行中」的届别参与当期计费。",
  "cancel": "取消",
  "save": "保存",
  "eGPresident": "如：会长",
  "baseAnnualFeeCNY": "基准年费(元)",
  "billingCycle6": "计费周期",
  "perTerm": "每届",
  "perYear": "每年",
  "displayOrder": "显示排序",
  "enabledStatus": "启用状态",
  "enabled": "启用",
  "disabled": "停用",
  "optionalEGHighestDecisionMaking": "选填，如：最高决策职务",
  "feeBaseAnnualFee": "会费 = 基准年费",
  "termMultiplierMemberTypeMultiplierCycle": "× 届别档位系数 × 会员类型系数 × 周期年数",
  "term4Multiplier13Years": "→ 第4届（系数 1 · 3年 · 2028-06-30 到期）：",
  "feePositionBaseAnnualFeeTerm": "会费 = 职务基准年费 × 届别档位系数 × 会员类型系数 × 周期年数。此处统一修改各会员类型的系数，保存后同时生效。",
  "examplePresidentBaseAnnualFee8": "试算基准：会长（基准年费 ¥8,000）× 届别系数 1 × 3 年 × 会员类型系数",
  "currentMultiplier": "当前系数",
  "newMultiplier": "新档位系数 *",
  "newMultiplier7": "新档位系数",
  "multipliersMustBe0AndMay": "档位系数须 ≥ 0，可填小数；每期示例随输入实时更新。保存后立即生效。",
  "enterATermName": "请填写届别名称",
  "selectTheTermStartDate": "请选择届期起始日",
  "selectTheTermEndDate": "请选择届末日期",
  "enterAMultiplier": "请填写档位系数",
  "enterAPositionName": "请填写职务名称",
  "enterABaseAnnualFee": "请填写基准年费",
  "selectABillingCycle": "请选择计费周期",
  "notSet": "暂未设置",
  "ended": "已结束",
  "upcoming": "未开始",
  "includedInBilling": "参与计费",
  "archived": "已归档",
  "notYetEffective": "未生效",
  "selectAMemberTypePositionAnd8": "请选择会员类型、职务和入会届别",
  "midTermFixedAmount": "中途入会 · 固定金额",
  "midTermProrated": "中途入会 · 折算",
  "midTermFullFee": "中途入会 · 全额",
  "couldNotLoadTerms": "届别列表加载失败",
  "couldNotLoadPositions": "职务列表加载失败",
  "couldNotLoadMemberTypes": "会员类型列表加载失败",
  "couldNotLoadMidTermEnrollment": "中途入会设置加载失败",
  "couldNotSaveMidTermEnrollment": "中途入会设置保存失败",
  "addAMemberTypeOnThe": "请先在入会申请页面新增会员类型",
  "enterAValidMultiplierForEvery": "请为所有会员类型填写有效系数（0–9999.9999）",
  "memberTypeRatesUpdated": "会员类型费率已更新",
  "couldNotSaveMemberTypeRates": "会员类型费率保存失败",
  "termUpdated": "届别已更新",
  "termAdded": "届别已新增",
  "couldNotSaveTerm": "届别保存失败",
  "deleteTerm": "删除届别",
  "termDeleted": "届别已删除",
  "couldNotDeleteTerm": "届别删除失败",
  "positionUpdated": "职务已更新",
  "positionAdded": "职务已新增",
  "couldNotSavePosition": "职务保存失败",
  "deletePosition": "删除职务",
  "positionDeleted": "职务已删除",
  "couldNotDeletePosition": "职务删除失败",
  "includedInCurrentBilling": "参与当期计费",
  "archivedExcludedFromCurrentBilling": "已归档，不参与当期计费",
  "notYetEffectiveExcludedFromBilling": "暂不参与计费（未生效）",
  "noAssociationMiniProgramInstancesAvailable": "当前没有可管理的商协会小程序实例",
  "thisAssociationFeatureWillBeAvailable": "该协会管理功能将在对应开发阶段接入",
  "noManageableMiniProgramInstances": "当前没有可管理的小程序实例",
  "couldNotLoadManageableMiniProgram": "暂时无法读取可管理的小程序实例",
  "message1": "{p0} 家",
  "message2": "较去年同期 {p0}",
  "message3": "含待审核申请 {p0}",
  "message4": "近 {p0} 天有登录 {p1} 人",
  "message5": "{p0} 张",
  "message6": "占在册会员 {p0}%",
  "message7": "占 {p0}%",
  "message8": "{p0} 年累计",
  "message9": "{p0} 笔未缴",
  "message10": "¥{p0} 万",
  "message11": "{p0}（{p1} – {p2} · 进行中）",
  "message12": "中途入会按固定金额 {p0} 计费（届期已进行 {p1} 个月）",
  "message13": "届期已进行 {p0} 个月（≥ 触发门槛 {p1} 个月），按剩余月份折算；入会日 {p2} · 距届末到期日（{p3}）剩 {p4} 个月 / 共 {p5} 个月",
  "message14": "届期已进行 {p0} 个月，未达 {p1} 个月门槛，按全额收取",
  "message15": "已切换为【{p0}】",
  "message16": "确认删除「{p0}」？删除后该届别不再参与会费计算。",
  "message17": "确认删除「{p0}」？",
  "message18": "{p0}（基准 {p1} · {p2}）",
  "message19": "{p0}（系数 {p1} · {p2}年 · {p3} 到期 · {p4}）",
  "message20": "固定金额 {p0}",
  "message21": "按剩余月份折算，门槛 {p0} 个月",
  "message22": "固定金额 {p0}（届期已开始后入会即按此金额收取）",
  "message23": "届期已进行满 {p0} 个月才触发折算，未满门槛按全额",
  "editTerm": "编辑届别",
  "editPosition": "编辑职务",
  "corporateMember": "企业会员",
  "groupMember": "团体会员",
  "individualMember": "个人会员",
  "member": "会员",
  "corporateRate": "企业会员档位系数",
  "groupRate": "团体会员档位系数",
  "individualRate": "个人会员档位系数",
  "feeFormula": "💡 应缴会费 = 职务基准年费 × 届别档位系数 × 会员类型系数 × 周期年数，中途入会再按剩余月份折算。当前届别：{term}。",
  "ruleExample": "示例：企业会员任会长（基准 ¥8000），第4届系数 1.0、届期 3 年 → 8000 × 1.0 × 1.2 × 3 = ¥28,800 / 届。本页只维护「单价规则」；具体每期该缴多少、已缴/待缴、续费与催缴见「续费管理」。本页改动即时生效、无需保存。",
  "termHelp": "届期状态按届期起始日 / 届末日期与当前日期自动判定：进行中的届别参与当期计费，已结束的届别归档、尚未开始的届别未生效。届末日期即会员到期日。当前：{date}。",
  "resultFormula": "基准年费 {base} × 届别系数 {term} × 类型系数 {type} = {annual} / 年\n计费周期：{cycle}（{years} 年）→ 每期应缴 {full}",
  "memberExpiry": "会员到期日：{end}（届期 {start}–{end}）",
  "termExample": "计费方式：基准年费 ¥8,000（会长） × 档位系数 {coefficient} × 类型系数 1.2（企业会员） × {years} 年 → 该届别每期会费 ≈ ¥{amount}（届期 {years} 年）",
  "positionExample": "会费 = 基准年费 {base} × 届别档位系数 × 会员类型系数 × 周期年数\n→ 第4届（系数 1 · 3年 · 2028-06-30 到期）：{amount}"
}
